<template>
  <div class="view view-activate">
    <div class="view-auth__form">
      <logo class="view-auth__logo" />
      <template v-if="user">
        <form
          ref="form"
          class="view-activate__form"
          @submit.prevent="setPassword()"
        >
          <template v-if="!user.verified">
            <h1 class="title">{{ $t("headings.welcomeToSimcision") }}</h1>
            <p class="mt-0">
              {{ $t("texts.onboardingPassword") }}
            </p>
          </template>
          <template v-else>
            <h1 class="title">{{ $t("headings.setNewPassword") }}</h1>
            <p class="mt-0">
              {{ $t("texts.setNewPassword") }}
            </p>
          </template>

          <input-text
            :disabled="true"
            :value="user.email"
            type="email"
            :label="$t('labels.email')"
          />

          <input-password
            v-model:value="data.password1"
            :label="$t('labels.password')"
            autocomplete="new-password"
            :required="true"
          />
          <input-password
            v-model:value="data.password2"
            :label="$t('labels.passwordRepeat')"
            autocomplete="new-password"
            :required="true"
          />

          <div v-if="!user.acceptedTermsAndPrivacyPolicy" class="mt-4">
            <input-checkbox v-model:value="data.acceptTerms" :required="true">
              <template #label>
                <i18n-t
                  keypath="labels.acceptTermsAndConditions"
                  scope="global"
                >
                  <template #agb>
                    <a :href="links.agb" target="_blank">{{
                      $t("labels.conditions")
                    }}</a>
                  </template>
                  <template #terms>
                    <a :href="links.terms" target="_blank">{{
                      $t("labels.termsOfUse")
                    }}</a>
                  </template>
                </i18n-t>
              </template>
            </input-checkbox>
            <input-checkbox
              v-model:value="data.acceptPrivacy"
              :required="true"
              class="mt-2"
            >
              <template #label>
                <i18n-t keypath="labels.readPrivacyNotice" scope="global">
                  <template #privacyNotice>
                    <a :href="links.privacy" target="_blank">{{
                      $t("labels.privacyPolicy")
                    }}</a>
                  </template>
                </i18n-t>
              </template>
            </input-checkbox>
          </div>

          <button class="button mt-4" type="submit">
            <template v-if="user.verified">
              {{ $t("actions.setPassword") }}
            </template>
            <template v-else>
              {{ $t("actions.activateAccount") }}
            </template>
          </button>

          <div v-if="data.errorMessage" class="message-error mt-4">
            {{ data.errorMessage }}
          </div>
        </form>
      </template>
      <template v-else>
        <p class="ta-center">
          {{ $t("messages.loadingData") }}
        </p>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import Logo from "@core/ui/SimcisionLogo.vue";
import InputText from "@core/input/InputText.vue";
import InputPassword from "@core/input/InputPassword.vue";
import InputCheckbox from "@core/input/InputCheckbox.vue";
import useTermsLinks from "../common/useTermsLinks";
import { useUser } from "@/api/user.store";

const { links } = useTermsLinks();
const { user, updateUser } = useUser();

const route = useRoute();
const router = useRouter();

const data = reactive({
  errorMessage: "",
  password1: "",
  password2: "",
  userData: "",
  userDataError: null,
  acceptTerms: false,
  acceptPrivacy: false
});

const redirectPath = computed(() => {
  if (route.redirectedFrom) {
    return {
      path: route.redirectedFrom.path
    };
  }
  return {
    name: "models-explorer"
  };
});

async function setPassword() {
  data.errorMessage = "";
  try {
    await updateUser({
      password: data.password1,
      acceptTerms: data.acceptTerms && data.acceptPrivacy
    });
    router.push(redirectPath.value);
  } catch (e) {
    const error = e as Error;
    if (error.message) {
      data.errorMessage = error.message;
    } else {
      console.log(error);
    }
  }
}
</script>

<style lang="scss">
.view-activate {
  padding: 1rem;
  flex-direction: column;

  &__logo {
    margin: 0 auto;
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
